<template>
    <div class="flex flex-col w-full justify-center gap-2 md:gap-2">
        <vx-box class="bg-slate-50 flex flex-col max-w-(--breakpoint-sm) p-8 text-xl mb-8" color="info">
            <h2 class="text-xl font-extrabold leading-7 text-slate-700">
                Subscriptions
            </h2>
            <p class="text-sm font-sans text-slate-500 lg:text-base">
                Subscriptions of this contact.
            </p>
        </vx-box>

        <div v-if="loading && !list.length" class="text-center py-10">
            <vx-icon-loading class="w-9 h-9 animate-loading-spin"></vx-icon-loading>
        </div>

        <template v-else>
            <vx-table v-if="list.length" class="xl:grid-cols-5" rowBreakpoint="xl">
                <vx-table-row isHeader>
                    <div>
                        Audience Type
                    </div>
                    <div>
                        Status
                    </div>
                    <div class="xl:col-span-2!">
                        Reason
                    </div>
                    <div>
                        Updated at
                    </div>
                </vx-table-row>
                <contact-custom-attribute-row v-for="(item, index) in list"
                    v-model="list[index]"
                    :key="item.id"></contact-custom-attribute-row>
            </vx-table>
        </template>
    </div>
</template>

<script setup>
import { watch } from 'vue';
import { VxBox, VxIconLoading, VxTable, VxTableRow } from '@voxie/frontend-components';
import ContactCustomAttributeRow from './ContactSubscriptionRow.vue';
import { useContactDetails } from '../useContactDetails';

const { subscriptions: list, loadingSubscriptions: loading, getSubscriptions, contact } = useContactDetails();

defineProps({
    contactId: {
        type: Number,
        required: true,
    },
});

watch(
    () => contact.value.id,
    async (id) => {
        if (!id) {
            return;
        }
        await getSubscriptions();
        setSubscriptions();
    },
    { immediate: true }
);

const setSubscriptions = () => {
    const types = ['marketing', 'transactional'];

    types.forEach((type) => {
        const hasSubscription = !!list.value.find(subscription => subscription.type === type);

        if (!hasSubscription) {
            list.value.push({
                type: type,
                status: 'unknown',
                reason_text: '-',
                updated_at: contact.value.created_at
            });
        }
    })
};
</script>
